import { render, staticRenderFns } from "./payment-receipt.vue?vue&type=template&id=1aee3fa4&scoped=true&"
import script from "./payment-receipt.vue?vue&type=script&lang=js&"
export * from "./payment-receipt.vue?vue&type=script&lang=js&"
import style0 from "./payment-receipt.vue?vue&type=style&index=0&id=1aee3fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee3fa4",
  null
  
)

export default component.exports